import moment from 'moment';

const IMAGES = {
  GENERIC: 'https://images.sofology.co.uk/image/upload/Xmas%202018/RDP/desktop/generic.jpg',
  QUICKSTOCK: 'https://images.sofology.co.uk/image/upload/Xmas%202018/RDP/desktop/quickstock.jpg',
  COUNT_7: 'https://images.sofology.co.uk/image/upload/Xmas%202018/RDP/desktop/7-days.jpg',
  COUNT_6: 'https://images.sofology.co.uk/image/upload/Xmas%202018/RDP/desktop/6-days.jpg',
  COUNT_5: 'https://images.sofology.co.uk/image/upload/Xmas%202018/RDP/desktop/5-days.jpg',
  COUNT_4: 'https://images.sofology.co.uk/image/upload/Xmas%202018/RDP/desktop/4-days.jpg',
  COUNT_3: 'https://images.sofology.co.uk/image/upload/Xmas%202018/RDP/desktop/3-days.jpg',
  COUNT_2: 'https://images.sofology.co.uk/image/upload/Xmas%202018/RDP/desktop/2-days.jpg',
  COUNT_1: 'https://images.sofology.co.uk/image/upload/Xmas%202018/RDP/desktop/1-days.jpg',
};

export function daysUntilCutOff(cutoff) {
  const daysTilXmas = cutoff.diff(moment().startOf('day'), 'days', false);
  if(daysTilXmas < 0) {
    return false;
  }
  return daysTilXmas;
}

export function getXmasImageForCase(daysUntilCutOff, range) {
  const { minSupplierLeadTime } = range;
  const hasQuickStock = !!range.catalogItemVariants.find(variant => variant.hasQuickStock);
  const daysLeftForRange = daysUntilCutOff - minSupplierLeadTime;
  if(daysLeftForRange > 7) return IMAGES.GENERIC;
  else if(daysLeftForRange > 0) return IMAGES[`COUNT_${daysLeftForRange}`];
  else if(hasQuickStock && ((daysUntilCutOff - 3) > 0)) return IMAGES.QUICKSTOCK;
  return '';
}




// WEBPACK FOOTER //
// ./src/services/xmasService.js